/*eslint-disable */

import appFooter from '@/components/public/common/footer/';
import {
  bus
} from '@/main';
import toast from '@/services/toast';
import variation_random_img1 from '@/assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from '@/assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from '@/assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from '@/assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from '@/assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from '@/assets/images/random_img/oddnary-variation-6.jpg';
import welcome from '@/components/welcome-popup/index';

var $ = window.jQuery = require('jquery');
export default {
  name: 'forgot-password',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome
  },
  props: [],
  data() {
    return {
      email: '',
      imageIndex:''
    }
  },
  computed: {

  },
  mounted() {
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
    if(localStorage.getItem('Reset_Email')){
      this.email = localStorage.getItem('Reset_Email')
    }else{
      this.email = ''
    }
    this.randomImgLoaded();
  },
  methods: {
    randomImgLoaded() {
      $('.app-loader').show()
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      this.imageIndex = x
      var element = document.getElementsByClassName('random_bgimg');
      if (x < images.length) {
        element[0].style["background-image"] = "url(" + variation_images[x] + ")"
        $('.navbar_list_wrp').addClass('act_contest_clr_of_holders' + x);
        setTimeout(() => {
          this.preloader = false;
          $('.app-loader').hide()
        }, 1500);
      }
    },
    validateBeforeForgotPasswordSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            email: this.email
          }
          this.$store.dispatch('forgotPasswordFun', data)
            .then((response) => {
              if (response.status == 200) {
                toast.success(response.data.msg);
                localStorage.getItem('Reset_Email', this.email)
                this.$router.push('/login/');
              }
            }).catch(function(err) {})
          return
        }
      })
    }
  },
  beforeCreate: function() {
    $('body').addClass('public-routes');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('public-routes');
    next();
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
  },
}